export class HizukeJohoModel{

  public shoriNendo: string;

  public shoriNengetsu: string;

  public shoriBi: string;

}



// WEBPACK FOOTER //
// ./src/app/modules/shared/data/hizuke-Joho-model.ts